import { fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';
import { putError } from '@/store/error.store';
import { fixDate } from '../../../../util/util';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

export const openPositionReducer = (state = fromJS({
  dateFrom: fixDate(moment().startOf('year').toDate()),
  dateTo: fixDate(moment().startOf('year').add(1, 'year').add(-1, 'day').toDate())
}), action) => {
  switch (action.type) {
    case 'OPEN_POSITION_LOADED':
      return state.set('data', fromJS(action.data));
    case 'OPEN_POSITION_WEEKLY_LOADED':
      return state.set('weekly', fromJS(action.data));
    case 'TRADES_CONCLUDED_LOADED':
      return state.set('tradesConcluded', fromJS(action.data));
    case 'TRADES_PROFITABILITY_LOADED':
      return state.set('tradesProfitability', fromJS(action.data)).set('done', true);
    case 'OPEN_POSITION_CLEAR':
      return state.clear();
    case 'OPEN_POSITION_UPDATE_DATE':
      return state.set('dateFrom', action.dateFrom).set('dateTo', action.dateTo);
    case 'OPEN_POSITION_PRODUCT_REPORT':
      return state.set('productReport', fromJS(action.data));
    default:
      return state;
  }
};

const dateOrEmpty = (date) => (date ? date.toDateString() : '');

export const clearPositionBook = dispatch => dispatch({ type: 'OPEN_POSITION_CLEAR' });
export const tradesProfitability = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'LOADING_TRADES_PROFITABILITY' });
  markStoreLoading(dispatch, 'TRADES_PROFITABILITY_REPORT');
  return RestAPI.get(`/api/report/tradesprofitability?from=${dateOrEmpty(dateFrom)
  }&to=${dateOrEmpty(dateTo)}`)
    .then(
      (data) => {
        dispatch({ type: 'TRADES_PROFITABILITY_LOADED', data });
        markStoreLoaded(dispatch, 'TRADES_PROFITABILITY_REPORT');
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'TRADES_PROFITABILITY_LOADING_FAILED' });
        markStoreLoaded(dispatch, 'TRADES_PROFITABILITY_REPORT');
        return true;
      },
    );
};

export const updateDate = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'OPEN_POSITION_UPDATE_DATE', dateFrom, dateTo });
};

export const tradesConcluded = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'LOADING_TRADES_CONCLUDED' });
  markStoreLoading(dispatch, 'LOADING_TRADES_CONCLUDED');
  return RestAPI.get('/api/report/tradesconcluded')
    .then(
      (data) => {
        dispatch({ type: 'TRADES_CONCLUDED_LOADED', data });
        tradesProfitability(dispatch, dateFrom, dateTo);
        markStoreLoaded(dispatch, 'LOADING_TRADES_CONCLUDED');
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'TRADES_CONCLUDED_LOADING_FAILED' });
        tradesProfitability(dispatch, dateFrom, dateTo);
        markStoreLoaded(dispatch, 'LOADING_TRADES_CONCLUDED');
        return true;
      },
    );
};

export const generateReportWeekly = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'LOADING_OPEN_POSITION_WEEKLY' });
  markStoreLoading(dispatch, 'OPEN_POSITION_WEEKLY');
  return RestAPI.get('/api/report/openpositionweekly')
    .then(
      (data) => {
        dispatch({ type: 'OPEN_POSITION_WEEKLY_LOADED', data });
        tradesConcluded(dispatch, dateFrom, dateTo);
        markStoreLoaded(dispatch, 'OPEN_POSITION_WEEKLY');
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'OPEN_POSITION_WEEKLY_LOADING_FAILED' });
        tradesConcluded(dispatch, dateFrom, dateTo);
        markStoreLoaded(dispatch, 'OPEN_POSITION_WEEKLY');
        return true;
      },
    );
};

export const generateProductReport = (dispatch) => {
  dispatch({ type: 'LOADING_OPEN_POSITION_PRODUCT_REPORT' });
  markStoreLoading(dispatch, 'OPEN_POSITION_PRODUCT_REPORT');
  return RestAPI.get('/api/report/avgCarrying').then(data => {
    dispatch({ type: 'OPEN_POSITION_PRODUCT_REPORT', data });
    markStoreLoaded(dispatch, 'OPEN_POSITION_PRODUCT_REPORT');
    return true;
  }).catch(data => {
    putError(dispatch, data);
    dispatch({ type: 'OPEN_POSITION_PRODUCT_REPORT_FAILED' });
    markStoreLoaded(dispatch, 'OPEN_POSITION');
    return true;
  });
};


export const generateReport = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'LOADING_OPEN_POSITION_REPORT' });
  markStoreLoading(dispatch, 'OPEN_POSITION');
  return RestAPI.get('/api/report/openposition')
    .then(
      (data) => {
        dispatch({ type: 'OPEN_POSITION_LOADED', data });
        generateReportWeekly(dispatch, dateFrom, dateTo);
        markStoreLoaded(dispatch, 'OPEN_POSITION');
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'OPEN_POSITION_LOADING_FAILED' });
        generateReportWeekly(dispatch, dateFrom, dateTo);
        markStoreLoaded(dispatch, 'OPEN_POSITION');
        return true;
      },
    );
};
